//  @flow
import * as React from "react";
import { useState } from "react";

import {
  Box, Typography,
} from "@mui/material";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import OrdersMain from "components/pages/seller/orders/OrdersMain";

import "./styles.scss";

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Orders = (props) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value}
              onChange={handleChange}
              variant="fullWidth"
              aria-label="">
          <Tab label="Orders" {...a11yProps(0)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} >
        <OrdersMain />
      </TabPanel>
    </Box>
  );
};

export default (Orders);
